import { HintPopup } from '@cobliteam/base-components/src/HintPopup/HintPopup';

interface OverflowHintTextProps {
  text: string;
  maxWidth: number;
  textStyle?: string;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const OverflowHintText = ({ text, maxWidth, textStyle }: OverflowHintTextProps) => {
  const measureText = (textToMeasure: string): number => {
    const ctx = document.createElement('canvas').getContext('2d')!;
    ctx.font = '14px "Roboto"';
    const { width } = ctx.measureText(textToMeasure);

    return width;
  };

  const textWidth = measureText(text);
  const shouldShowHint = textWidth >= maxWidth;

  if (shouldShowHint) {
    return (
      <HintPopup title={text} arrow placement='top-start'>
        <span className={textStyle || ''}>{text}</span>
      </HintPopup>
    );
  }
  return <span className={textStyle || ''}>{text}</span>;
};

export default OverflowHintText;
